// 标记
export default {
    marker: '标记',
    folder: '文件夹',
    creationTime: '创建时间',
    sameDay: '当天',
    thisWeek: '本周',
    thisMonth: '本月',
    thisYear: '今年',
    all: '全部',
    place: '地点',
    addPoints: '添加点',
    addLine: '添加线',
    addPolygon: '添加区域',
    markerInfo: '标注信息',
    lng: '经度',
    lat: '纬度',
    alt: '海拔',
    color: '颜色',
    icon: '图标',
    remarks: '备注',
    unnamedLine: '未命名线',
    linetype: '线型',
    lineWidth: '线宽',
    solidLine: '实线',
    dottedLine: '虚线',
    dashDot: '点画线',
    transparent: '透明',
    arrowPosition: '箭头位置',
    startingPoint: '起点',
    end: '终点',
    arrowDirection: '箭头方向',
    forward: '正向',
    reverse: '反向',
    shape: '形状',
    unnamedFaces: '未命名面',
    sideLength: '边长',
    long: '长',
    wide: '宽',
    numberSides: '边数',
    radius: '半径',
    cancel: '取消',
    complete: '完成',
    clickCut: '点击地图开始裁剪',
    areaName: '区域名称',
    enterName: '请输入区域名称',
    enterContent: '请输入内容',
    save: '保存',
    delete: '删除',
    originalArea: '原始区域',
    determine: '确定',
    tips: '提示',
    search:'搜索',
    importKML:'导入KML',
    exportKML:'导出KML',
    addFolders:'添加文件夹',
    share:'分享',
    unnamedPoint:'未命名点',
    enterNameSearch:'请输入名称进行搜索',
    fileImport:'文件导入',
    destinationFolder:'目标文件夹',
    edit:'编辑',
    showHide:'显示/隐藏',
    createdBy:'创建人',
    editFolder:'编辑文件夹',
    addFolder:'新建文件夹',
    enterFolderName:'请输入文件夹名称',
    quickSharing:'快速分享',
    onlineEquipment:'在线设备',
    uav:'无人机',
    rtkStation:'RTK基站',
    refresh:'刷新',
    copy:'复制',
    use:'使用',
    sharedUsers:'共享用户',
    more:'更多',
    pleaseSelect:'请选择',
    nothing:'无',
    folderName:'文件夹名称',
    triangle:'三角形',
    rectangle:'矩形',
    polygon:'多边形',
    circular:'圆',
    free:'自由',
    enterDeviceSearch:'请输入设备名称搜索',
    notLocated:'未定位',
    singlePointPositioning:'单点定位',
    diffPositioning:'差分定位',
    fixedUnposition:'固定解定位',
    floatingPointRelocation:'浮点解定位',
    inertialNavigationPositioning:'惯导定位',
    setPositioning:'设置定位',
    noPositioning:'无定位',
    gpsPositioningError:'GPS定位差',
    rtkSinglePointPositioning:'RTK单点解定位',
    rtkDiffPositioning:'RTK差分解定位',
    rtkFloatingPointRelocation:'RTK浮点解定位',
    rtkFixedPositioning:'RTK固定解定位',
    gpsPositioning:'GPS定位',
    mobilePhone:'手机',
    importRouteList:'导入航线列表',
    delTip:'标记删除后无法恢复, 是否继续?',
    pleaseSelectAtLeastOneTag:'请至少选中一个标记',
    sharingSuccessful:'分享成功',
    markingSurface:'标记面',
    dbclickCut:'双击地图或点击最后一个点完成裁剪',
    cutAtLeastOnce:'至少切割一次',
    markingLine:'标记线',
    markPoint:'标记点'



}
